export const AMP_EVENTS_SOURCES_READY = 'plugin:AmpEventsSources:ready'
export const PLUGIN_TRACKING_EVENT = "PLUGIN:TRACKING:EVENT";
